import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
// import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import { Container, Row,Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="School Management Committee" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>

                        <Col md={3} className='c-left custom-padding-color mb-4'>
                        <Committeeleft></Committeeleft>
                        </Col>
                
                        <Col md={9} className='c-right'>

                            
                                <h3 className='c-headline mb-3'>School Management Committee</h3>
                                <p className='c-lineheight2dot5'>The School Management Committee of the Institute is re-constituted with the following members, with immediate effect and until further orders
:  </p>

                                {/* <Link className='c-link' to="icc@iittp.ac.in" target="_blank" >icc@iittp.ac.in </Link> */}

                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Dr. B Ravinder</p>
                                                <p>Assistant Professor - Department of Mathematics and Statistics </p>
                                            </td>
                                            <td>Chairman</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Dr. S Raja</p>
                                                <p>Assistant Professor - Department of Computer Science and Engineering
                                               
                                                </p>
                                            </td>
                                            <td> Co-Chair</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Payel Sen</p>
                                                <p>Assistant Professor - Department of Chemical Engineering
                                               
                                                </p>
                                            </td>
                                            <td> Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. M Nabil</p>
                                                <p>Associate Professor - Department of Chemical Engineering</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. Pradeep S Valan</p>
                                                <p>Assistant Registrar - Recruitment Section</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. G Ramesh</p>
                                                <p>Junior Technical Superintendent - Computer Center</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>P Midhun Kumar</p>
                                                <p>Senior Assistant - Finance and Accounts Section</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. M Venkat Ramana</p>
                                                <p>Assistant Registrar - Academics Section</p>
                                            </td>
                                            <td>Convenor</td>
                                        </tr>

                                        
                                    </tbody>

                                </Table>

                               


                                

                                </Col>

                           
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;